import React from "react";
import { format } from "date-fns";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";

const tableHead = [
  "Sr.",
  "Week",
  "Week Start Date",
  "WPL",
  "WPH",
  "RPL",
  "RPH",
];

const PriceWatcherViewTable = ({
  data = [],
  agro = [],
  currentPage,
  itemsPerPage,
}) => {
  const formatDate = (dateStr) => format(new Date(dateStr), "dd MMMM yyyy");

  function calculateDiscountedPrice(originalPrice, discount) {
    const discountedPrice = originalPrice * (1 - discount);
    return discountedPrice;
  }

  return (
    <div className="table-responsive border-top">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;

            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  {item?.isPriceIncreased ? (
                    <IoIosArrowRoundUp size={24} color="green" />
                  ) : (
                    <IoIosArrowRoundDown size={24} color="red" />
                  )}
                  {item?.week || "N/A"} ({item?.year || "N/A"})
                </td>
                <td>{formatDate(item?.weekStartDate) || "N/A"}</td>
                <td>
                  ₹
                  {calculateDiscountedPrice(item?.weeklyPrice, 0.35)?.toFixed(
                    2
                  ) || "N/A"}
                </td>
                <td>
                  ₹
                  {calculateDiscountedPrice(item?.weeklyPrice, 0.15)?.toFixed(
                    2
                  ) || "N/A"}
                </td>
                <td>
                  ₹
                  {calculateDiscountedPrice(item?.weeklyPrice, 0.05)?.toFixed(
                    2
                  ) || "N/A"}
                </td>
                <td>₹{item?.weeklyPrice || "N/A"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PriceWatcherViewTable;
